/* Custom Accordion: Footer - Cart - Product Info Tabs */

function mobileAccordion() {
    const els = [...document.querySelectorAll('.open-toggle > .column-title')];
    els.forEach(el => {
      if(typeof el.dataset.init !== 'undefined') return;
      el.dataset.init = 'true';
      el.addEventListener('click', handleCustomAccorion)
      if(el.nextElementSibling.matches('.active')) el.nextElementSibling.style.height = `${el.nextElementSibling.offsetHeight}px`;
    });
  }

  function handleCustomAccorion(e) {
    e.preventDefault();
    if(typeof e.currentTarget.dataset.init === 'undefined') return;
    const nEl = e.currentTarget.nextElementSibling,
      oTxt = e.currentTarget.dataset.openText,
      cTxt = e.currentTarget.dataset.closedText;
    let _hasPe = !1, _ph = null, _pe = null, _peih = null;

    /* Handle Nested */
    if(e.currentTarget.dataset.nested === 'true' && matchMedia('(hover: none), (pointer: coarse)').matches && window.innerWidth <= 1024) {
      _hasPe = !0;
      _pe = e.currentTarget.closest('.no-bullet.active');
    }
    /* Handle Nested */
    
    if(!nEl.classList.contains('active')) {
      const p = e.currentTarget.closest('.columns-wrapper'),
        tEl = p.querySelector(':scope > .open-toggle.active');
      if(oTxt && cTxt) e.currentTarget.querySelector('span').textContent = oTxt;
      if(tEl) {
        const tnEl = tEl.querySelector('.no-bullet.active');
        closeCustomAccordion(tEl,tnEl);
      }
      e.currentTarget.closest('.open-toggle').classList.toggle('active');
      nEl.classList.toggle('active');
      nEl.style.height = 'auto';
      const _h = `${nEl.clientHeight}px`;
      /* Handle Nested */
      if(_hasPe) {
        _peih = `${_pe.clientHeight}px`;
        _pe.style.height = 'auto';
        _ph = `${_pe.clientHeight}px`;
        _pe.style.height = _peih;
      }
      /* Handle Nested */
      nEl.style.height = '0px';
      setTimeout(function() {
        nEl.style.height = _h;
        /* Handle Nested */
        if(_hasPe) _pe.style.height = _ph;
        /* Handle Nested */
      }, 0);
    } else {
      if(oTxt && cTxt) e.currentTarget.querySelector('span').textContent = cTxt;
      /* Handle Nested */
      if(_hasPe) {
        _pe.style.height = `${_pe.clientHeight-nEl.clientHeight}px`;
      }
      /* Handle Nested */
      closeCustomAccordion(e.currentTarget,nEl);
    }
  }

  function closeCustomAccordion(triggerEl,listEl) {
    /* Handle Videos inside Accordion */
    if(triggerEl.closest('.columns-wrapper').querySelector('[data-has-video="true"]')) {
      triggerEl.closest('.columns-wrapper').querySelectorAll('[data-has-video="true"]').forEach(el => {
        if(el.querySelector('video')) el.querySelector('video').pause();
      });
    }
    /* Handle Videos inside Accordion */
    triggerEl.closest('.open-toggle').classList.toggle('active');
    listEl.style.height = '0px';
    listEl.addEventListener('transitionend', function () {
      listEl.classList.remove('active');
    }, {
      once: true
    });
  }

  window.addEventListener('DOMContentLoaded', mobileAccordion);
/* Custom Accordion: Footer - Cart - Product Info Tabs */
